<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <e-collapse title="基础设置" :expand="true">
      <t-form-item label="尺寸">
        <t-radio-group
          size="small"
          v-model="attribute.size"
          @change="changeSize"
        >
          <t-radio-button value="small">小</t-radio-button>
          <t-radio-button value="medium">中</t-radio-button>
          <t-radio-button value="large">大</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="宽度">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="attribute.width"
          :decimal-places="0"
        />
      </t-form-item>
      <t-form-item label="高度">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="attribute.height"
          :decimal-places="0"
        />
      </t-form-item>
      <t-form-item label="圆角">
        <t-input-number
          size="small"
          v-model="attribute.borderRadius"
          :min="0"
          :max="9999"
          :decimal-places="0"
        />
      </t-form-item>
      <!-- <t-form-item label="徽标形状">
        <t-radio-group size="small" v-model="attribute.badgeShape">
          <t-radio-button value="circle">circle</t-radio-button>
          <t-radio-button value="round">round</t-radio-button>
        </t-radio-group>
      </t-form-item> -->
      <t-form-item label="显示徽标">
        <t-tooltip content="当数值为 0 时，是否展示徽标">
           <t-switch size="small"  v-model="attribute.showZero" :label="['是', '否']"/>
        </t-tooltip>
      </t-form-item>
      <t-form-item label="背景颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.bgColor"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="字体设置" :expand="true">
      <t-form-item label="字体颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.textColor"
        />
      </t-form-item>
      <t-form-item label="字体样式">
        <t-radio-group size="small" v-model="attribute.fontStyle">
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="italic">斜体</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="加粗">
        <t-radio-group size="small" v-model="attribute.fontWeight">
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="bold">加粗</t-radio-button>
          <t-radio-button value="lighter">更细</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="字体">
        <t-select size="small" v-model="attribute.fontFamily">
          <t-option
            v-for="item in textFamilyList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </t-select>
      </t-form-item>
      <t-form-item label="字体大小">
        <t-input-number
          size="small"
          :min="0"
          :max="100"
          v-model="attribute.fontSize"
          :decimal-places="0"
        />
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
export default {
  name: "cpt-badge-option",
  props: {
    attribute: Object,
    cptDataForm: Object,
  },
  components: { CptData },
  created() {
    this.textFamilyList = require("@/assets/font/font-list");
  },
  data() {
    return {
      sizeOptions: {
        small: { width: 8, height: 16, borderRadius: 8 },
        medium: { width: 10, height: 20, borderRadius: 10 },
        large: { width: 12, height: 24, borderRadius: 12 },
      },
    };
  },
  methods: {
    changeSize(val) {
      const sizeAttributes = this.sizeOptions[val];
      if (sizeAttributes) {
        this.attribute.width = sizeAttributes.width;
        this.attribute.height = sizeAttributes.height;
        this.attribute.borderRadius = sizeAttributes.borderRadius;
      } else {
        console.warn(`Invalid size option: ${val}`);
      }
    },
  },
};
</script>

<style scoped>
</style>